import React, { useEffect } from 'react';
import { pathOr, pick } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Box, Typography, Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { apiErrorsToFormik } from 'utils/errors';

import LoanOfficerPresenter from 'presenters/administrator/LoanOfficerPresenter';
import useAdministratorsLoanOfficers from 'reducers/hooks/administrators/useLoanOfficers';
import useAdministratorsLoanOfficer from 'reducers/hooks/administrators/useLoanOfficer';

import { appRoutes } from 'routes';
import Loader from 'sharedComponents/Loader';
import LoanOfficerForm from './components/LoanOfficerForm';

import useStyles from './useStyles';

const AdminLoanOfficer = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id } = useParams();

  const { loadLoanOfficer, loanOfficer, isLoanOfficerLoading, isLoanOfficerIdle } = useAdministratorsLoanOfficers();
  const { updateLoanOfficer, approveLoanOfficer, isLoanOfficerApproving } = useAdministratorsLoanOfficer();

  useEffect(() => {
    loadLoanOfficer(id);
  }, []);

  const handleSubmit = async (values, { setErrors }) => {
    const preparedValues = {
      ...values,
      companyNmls: values.savedMortgageCompanyNmls,
      mortgageCompany: values.savedCompany,
    };
    const params = pick(['mortgageCompany', 'email', 'companyNmls', 'nmls'], preparedValues);
    try {
      await updateLoanOfficer({ ...params, loanOfficerId: id });
      loadLoanOfficer(id);
    } catch (error) {
      const errors = apiErrorsToFormik(error);
      setErrors(errors);
    }
  };

  const handleApproveLoanOfficer = async () => {
    await approveLoanOfficer({ id });
    loadLoanOfficer(id);
  };

  const isLoading = isLoanOfficerLoading || isLoanOfficerIdle;

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <Loader />
      </div>
    );
  }

  const loanOfficerAttributes = pathOr({}, ['data', 'attributes'], loanOfficer);
  const isVerified = LoanOfficerPresenter.isVerified(loanOfficerAttributes);

  return (
    <Box className={classes.container}>
      <Box className={classes.paper}>
        <Typography variant="h1">{t('components.AdministratorLoanOfficer.header')}</Typography>
        <LoanOfficerForm loanOfficer={loanOfficerAttributes} onSubmit={handleSubmit} />
        <Button
          className={classes.button}
          disabled={isVerified || isLoanOfficerApproving}
          onClick={handleApproveLoanOfficer}
        >
          {t('components.AdministratorLoanOfficer.approve')}
        </Button>
        <Button className={classes.button} to={appRoutes.adminRootPath()} component={RouterLink} color="secondary">
          {t('components.AdministratorLoanOfficer.back')}
        </Button>
      </Box>
    </Box>
  );
};

export default AdminLoanOfficer;



// WEBPACK FOOTER //
// ./src/components/AdminLoanOfficer/AdminLoanOfficer.js